(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this._logoTimer = null;
      this.onLogoScrollHandler = this.onLogoScroll.bind(this);
      window.addEventListener('scroll', this.onLogoScrollHandler, { passive: true });

      // Hidden on scroll down: a pointer within 2x the header's height of the top
      // asks for it back, and holds it open until the pointer moves away.
      this.revealedByPointer = false;
      this.pointerFrame = null;
      this.onPointerMoveHandler = this.onPointerMove.bind(this);
      this.onPointerLeaveHandler = this.onPointerLeave.bind(this);
      if (!this.headerIsAlwaysSticky && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mousemove', this.onPointerMoveHandler, { passive: true });
        document.documentElement.addEventListener('mouseleave', this.onPointerLeaveHandler);
      }

      this.createObserver();
    }

    setHeaderHeight() {
      const headerHeight = `${this.offsetHeight - 2}px`;
      document.documentElement.style.setProperty('--header-height', headerHeight);
      if (!this.header.classList.contains('shopify-section-header-hidden')) {
        document.documentElement.style.setProperty('--header-offset', headerHeight);
      }
    }

    // Space the visible header takes at the top; sticky bars sit just below it.
    setHeaderOffset(isHidden) {
      document.documentElement.style.setProperty('--header-offset', isHidden ? '0px' : `${this.offsetHeight - 2}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('scroll', this.onLogoScrollHandler);
      document.removeEventListener('mousemove', this.onPointerMoveHandler);
      document.documentElement.removeEventListener('mouseleave', this.onPointerLeaveHandler);
      cancelAnimationFrame(this.pointerFrame);
      clearTimeout(this._logoTimer);
    }

    onPointerMove(event) {
      if (this.pointerFrame) return;
      const pointerY = event.clientY;
      this.pointerFrame = requestAnimationFrame(() => {
        this.pointerFrame = null;
        const inRevealZone = pointerY <= (this.offsetHeight - 2) * 2;
        const isHidden = this.header.classList.contains('shopify-section-header-hidden');

        if (inRevealZone) {
          this.preventHide = true;
          if (isHidden) {
            this.revealedByPointer = true;
            this.reveal();
          }
        } else {
          this.releasePointerReveal();
        }
      });
    }

    onPointerLeave() {
      this.releasePointerReveal();
    }

    // Pointer moved off: hide again only if it was the pointer that brought it back.
    releasePointerReveal() {
      this.preventHide = false;
      if (!this.revealedByPointer) return;
      this.revealedByPointer = false;
      if (this.header.classList.contains('scrolled-past-header')) this.hide();
    }

    onLogoScroll() {
      if (window.innerWidth >= 750) return;
      const shouldShrink = window.scrollY > 80;
      const isShrunk = this.header.classList.contains('is-scrolled');
      if (shouldShrink === isShrunk) return;
      this.header.classList.toggle('is-scrolled', shouldShrink);
      clearTimeout(this._logoTimer);
      this._logoTimer = setTimeout(() => this.setHeaderHeight(), 320);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        // Scrolling up wants the header for its own sake — keep it when the pointer leaves.
        this.revealedByPointer = false;
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setHeaderOffset(true);
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderOffset(false);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.revealedByPointer = false;
      this.setHeaderOffset(false);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // PDP back button → browser history (falls back to home)
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-history-back]')) return;
    e.preventDefault();
    if (window.history.length > 1) window.history.back();
    else window.location.href = '/';
  });

  // Warm the cart page on pointer proximity (see below). Nav-link hover prefetch
  // is handled globally by assets/prefetch-links.js via the data-prefetch attribute.
  (function () {
    const prefetched = new Set();

    // Shopify serves all storefront HTML as `Cache-Control: private, no-store`,
    // which <link rel="prefetch"> refuses to reuse (it re-fetches on click — a
    // wasted round trip). The Speculation Rules API keeps its prefetch in a
    // dedicated navigational cache that IS used for no-store pages, so the click
    // activates the prefetch with no second document request. Fall back to
    // <link rel="prefetch"> where speculation rules aren't supported.
    const supportsSpeculationRules =
      typeof HTMLScriptElement !== 'undefined' && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');

    function prefetch(url) {
      if (!url || prefetched.has(url)) return;
      prefetched.add(url);
      if (supportsSpeculationRules) {
        const s = document.createElement('script');
        s.type = 'speculationrules';
        s.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [url] }] });
        document.body.appendChild(s);
      } else {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url;
        document.head.appendChild(link);
      }
    }

    // Warm the cart page as soon as the pointer comes within 200px of the cart
    // icon (distance to its bounding box), so the click navigates instantly.
    // Fires once, then detaches; keyboard focus prefetches too.
    var cartEl = document.querySelector('.header__action--cart');
    if (cartEl) {
      var CART_RADIUS = 200;
      var onMove = function (e) {
        var r = cartEl.getBoundingClientRect();
        var dx = Math.max(r.left - e.clientX, 0, e.clientX - r.right);
        var dy = Math.max(r.top - e.clientY, 0, e.clientY - r.bottom);
        if (dx * dx + dy * dy <= CART_RADIUS * CART_RADIUS) {
          prefetch(cartEl.href);
          document.removeEventListener('mousemove', onMove);
        }
      };
      document.addEventListener('mousemove', onMove, { passive: true });
      cartEl.addEventListener('focus', function () {
        prefetch(cartEl.href);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Immediate loading feedback. facets.js debounces the actual request (~800ms),
  // so it only adds `.loading` well after the click — show the grid loader the
  // moment a filter/sort changes. facets.js re-adds the class on submit and drops
  // it when it swaps in the new grid, so this just closes the perceived gap.
  document.addEventListener('change', (event) => {
    if (!event.target.closest('facet-filters-form')) return;
    document.querySelector('#ProductGridContainer .collection')?.classList.add('loading');
    // Applying a filter/sort resets the list — bring the top of the listing into
    // view (scroll-margin-top keeps it clear of the sticky header).
    document.querySelector('.plp')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();
})();
